export default "CEE BAT-* tertiaire 2026 — Primes patrimoine tertiaire | Solution Éco France";
